import {createReducer, on} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';
import {Bundle, CollectionMetadata} from '../../../models/clare';
import {BundleListActions} from './bundle-list.actions';

export const bundleListFeatureKey = 'bundleList';

export interface BundleListState {
  items: Bundle[];
  paginationMeta: CollectionMetadata;
  loading: boolean;
  error: ProductManagementErrorInterface | undefined;
}

export const initialBundleListState: BundleListState = {
  items: [],
  paginationMeta: {result_type: 'Items::Bundle', pagination: {}} as CollectionMetadata,
  loading: false,
  error: undefined,
};

function updateItemById(items: Bundle[], bundle: Bundle): Bundle[] {
  return items.map(item => (String(item.id) === String(bundle.id) ? bundle : item));
}

export const reducer = createReducer(
  initialBundleListState,
  on(BundleListActions.loadBundles, state => ({...state, loading: true})),
  on(BundleListActions.loadBundlesSuccess, (state, action) => ({
    ...state,
    items: [...action.bundles.result],
    paginationMeta: action.bundles.metadata,
    loading: false,
  })),
  on(BundleListActions.loadBundlesFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
  on(BundleListActions.toggleBundleActiveStatus, state => ({...state, loading: true})),
  on(BundleListActions.toggleBundleActiveStatusSuccess, (state, action) => ({
    ...state,
    items: updateItemById(state.items, action.bundle),
    loading: false,
  })),
  on(BundleListActions.toggleBundleActiveStatusFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  }))
);

export const getItems = (state: BundleListState): Bundle[] => state.items;
export const getPaginationMeta = (state: BundleListState): CollectionMetadata => state.paginationMeta;
export const getLoading = (state: BundleListState): boolean => state.loading;
export const getError = (state: BundleListState): ProductManagementErrorInterface | undefined => state.error;
